module.exports = __webpack_public_path__ + "static/media/map-pin.a17c0909.svg";